<template>
  <nuxt-link
    class="card-latest-winners"
    :class="{ 'card-latest-winners--mini': isMini }"
    :to="gameUrl"
    @click="handleClick"
  >
    <div v-if="src" class="card-latest-winners__wrap-img">
      <atomic-image :src="src" />
    </div>

    <div v-else class="card-latest-winners__meta">
      {{ gameName }}
    </div>

    <div class="card-latest-winners__wrap">
      <div class="card-latest-winners__text card-latest-winners__text--tertiary">{{ nickname || 'Unknown' }}</div>

      <div v-if="!isMini" class="card-latest-winners__text">{{ gameName }}</div>

      <div class="card-latest-winners__prize">
        <atomic-image
          class="card-latest-winners__currency-icon"
          :src="`${iconUrl}/${currency}.svg`"
          :defaultImage="DEFAULT_IMG"
        />

        <div class="card-latest-winners__text card-latest-winners__text--amount">
          + {{ formatValue(formatedSum.amount?.toFixed(2)) }} {{ formatedSum.currency }}
        </div>
      </div>
    </div>
  </nuxt-link>
</template>

<script setup lang="ts">
  import type { IGame, IGameImages } from '@skeleton/core/types';

  import { DEFAULT_IMG } from '@skeleton/consts/staticPath';
  import { ModalName } from '@skeleton/consts/modals';

  const props = defineProps<{
    nickname: Maybe<string>;
    amount: number;
    currency: string;
    payout?: number;
    resultBalance?: number;
    game: IGame;
    gameName: string;
    isDemoMode: boolean;
    gameImages: IGameImages;
    isMini?: boolean;
  }>();

  const { openModalSync } = useModalStore();
  const profileStore = useProfileStore();
  const { isLoggedIn } = storeToRefs(profileStore);
  const { localizePath, getImageUrl, formatBalance } = useProjectMethods();

  const gameUrl = computed(() => {
    try {
      const { identity } = props.game;

      if (isLoggedIn.value) {
        return localizePath(`/game/${identity}`);
      }

      if (props.isDemoMode) {
        return localizePath(`/game/${identity}?demo=true`);
      }

      return '';
    } catch {
      return '';
    }
  });

  const handleClick = () => {
    if (!gameUrl.value) {
      openModalSync(ModalName.SIGN_UP);
    }
  };

  const formatedSum = computed(() => formatBalance(props.currency, props.payout || props.resultBalance));

  const { iconUrl } = useDynamicIcon('currency');

  const src = computed(() => getImageUrl(props.gameImages, 'vertical'));
</script>

<style src="~/assets/styles/components/card/latest-winners.scss" lang="scss" />
